import axios from 'axios'
import Vue from 'vue'
import { Toast } from 'vant'
import router from '../router'

Vue.use(Toast)
let toast = null
let token = ''
// 开了反向代理不要设置基路径 否则会失效
// axios.defaults.baseURL = baseURL;
axios.defaults.headers.common.token = token // 设置请求头里面的 token
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded' // 设置POST提交数据的文档类型编码

// Interceptors 拦截器
// Add a request interceptor (添加请求的拦截器 发送之前要做业务逻辑)
axios.interceptors.request.use(function(config) {
  token = localStorage.getItem('token') || token
  // config.headers.token = token // 客户端发送 token  到服务器  绑定到 req.headers
  config.headers['access-auth-token'] = token
  toast = Toast.loading({
    message: '加载中...',
    forbidClick: true
  })
  // console.log('config', config)
  return config
}, function(error) {
  // Do something with request error(请求发送失败)`
  return Promise.reject(error)
})
// var that = this
// Add a response interceptor (添加响应的拦截器 服务器响应数据到客户端之前)
axios.interceptors.response.use(function(response) {
  setTimeout(() => {
    toast.clear()
  }, 500)
  // console.log('response', response)
  if (  response.status === 200 ) {
    if (response.data.code != 0) {
      if (response.data.code == 4000) {
        localStorage.removeItem("token");
        toast = Toast({
          message: '登录失效！',
          forbidClick: false
        })
        setTimeout(() => {
          router.push('/home')
        }, 2000)
      } else {

      }
    }
  }
  return response
  // return response.data
}, function(error) {
  // Do something with response error (响应失败的业务逻辑)
  // if(error.response.status === 401) {
  console.log('ooo', error)
  if(error.response.status === 401) {
    // 401 说明 token 验证失败
    // 可以直接跳转到登录页面，重新登录获取 token
    console.log('xxxx')
    toast = Toast({
      message: '登录失效！',
      forbidClick: false
    })
    setTimeout(() => {
      router.push('/start')
    }, 2000)
  } else if (error.response.status === 500) {
     // 服务器错误
     // do something
     return Promise.reject(error)
  }
  // 返回 response 里的错误信息
  // return Promise.reject(error.response.data)
  return Promise.reject(error)
})

export { axios }
